module.exports = {
  footerText: "Copyright ODOPASS © 2021"
}
